import {
  CONTRACT_FIELDS,
  CONTRACT_LABELS,
  type PricingValidationSchemaApi,
  VALIDATION_SCHEMA_KEYS,
  type ValidationSchema,
  type ValidationSchemaKey,
  type ValidationSchemas,
} from '../../models';
import type { JSchema } from '../../types';
import { parseJSONSchema, resolvePropertiesLabels, resolvePropertiesNames } from '../../utils';

type PropertyLabels = Record<string, string | Record<string, string>>;

export const mapPropertyLabels = (schemaKey: ValidationSchemaKey): PropertyLabels => {
  const mapper: Partial<Record<ValidationSchemaKey, PropertyLabels>> = {
    [VALIDATION_SCHEMA_KEYS.contract.create]: CONTRACT_LABELS,
  };

  return mapper[schemaKey] || {};
};

export const mapPropertyNames = (schemaKey: ValidationSchemaKey): Record<string, string> => {
  const mapper: Partial<Record<ValidationSchemaKey, Record<string, string>>> = {
    [VALIDATION_SCHEMA_KEYS.contract.create]: CONTRACT_FIELDS,
  };

  return mapper[schemaKey] || {};
};

export const parseValidationSchema = (data: string, schemaKey: ValidationSchemaKey): JSchema => {
  const schema = resolvePropertiesNames(parseJSONSchema(data), mapPropertyNames(schemaKey));

  return resolvePropertiesLabels(schema, mapPropertyLabels(schemaKey));
};

export const normalizeValidationSchemas = (data: PricingValidationSchemaApi[]): Partial<ValidationSchemas> => {
  if (!data || data.length === 0) {
    return {};
  }

  return data.reduce((acc, curr) => {
    if (curr.schemaName && curr.validationSchema) {
      const schemaKey = curr.schemaName;

      acc[schemaKey] = {
        createOn: curr.createdOn ?? undefined,
        customerKey: curr.customerId ?? undefined,
        enabledFrom: curr.enabledFrom ?? undefined,
        enabledTo: curr.enabledTo ?? undefined,
        modifiedOn: curr.modifiedOn ?? undefined,
        schemaKey,
        validationSchema: parseValidationSchema(curr.validationSchema, schemaKey),
      } as ValidationSchema;
    }

    return acc;
  }, {} as ValidationSchemas);
};
